module.exports = __webpack_public_path__ + "assets/img/huodai.c8ffb246.png";